import {BaseClient} from '../utils/base-client';

class CustomPropertyClient extends BaseClient {
  buildEndpoint({projectId, workspaceId, customPropertyId, validate}) {
    let endpoint =
      `api/app/` + (workspaceId ? `workspaces/${workspaceId}` : `projects/${projectId}`) + `/custom_properties/`;
    if (customPropertyId) {
      endpoint += `${customPropertyId}`;
    } else if (validate) {
      endpoint += `validate`;
    }

    return endpoint;
  }

  buildRequestBody({customProperty}) {
    return JSON.stringify(customProperty);
  }

  processResponse(response) {
    return response;
  }
}

export const customPropertyClient = new CustomPropertyClient();
